module.exports = __webpack_public_path__ + "img/7.ec7278d0.jpg";